import React, { useEffect, useState } from 'react';

import { Status } from '@/generated/GeneratedApiTypes';

interface BarChartProps {
    value: number;
    status: Status;
    textColorClass?: string;
}

const getStatusClass = (status: Status): string =>
    ({
        [Status.WARNING]: 'progress-bar-warning',
        [Status.DANGER]: 'progress-bar-danger',
        [Status.UNKNOWN]: '',
        [Status.NORMAL]: '',
    })[status] || '';

const BarChart: React.FC<BarChartProps> = ({ value, status, textColorClass = 'text-color-gray-darkest' }) => {
    const [valueToRender, setValueToRender] = useState(0);
    useEffect(() => {
        setTimeout(() => setValueToRender(value), 100);
    }, []);
    return (
        <div className="width-100pct display-flex align-items-center">
            <div className="progress margin-0 flex-1-0 progress-animated">
                <div
                    className={`progress-bar ${getStatusClass(status)}`.trim()}
                    style={{ width: `${valueToRender}%` }}
                />
            </div>
            <div className={`margin-left-10 ${textColorClass}`}>{`${valueToRender} %`}</div>
        </div>
    );
};

export default BarChart;
